import {
  Tooltip,
  Legend,
  Pie,
  PieChart,
  Cell,
  ResponsiveContainer
} from "recharts";
import { useState, useEffect } from "react";
import "./Charts.css";
import { handleClickLogic } from "../../utils/filterFunctions";

const CustomPieChart = ({ showData, xKey, title, selectedKey, frozenKey, onBarClick }) => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isFrozen, setIsFrozen] = useState(false);
  const [frozenData, setFrozenData] = useState(null);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AA66CC"];

  const dataToRender = isFrozen ? frozenData : showData;

  useEffect(() => {
    setSelectedCategory(selectedKey);
  }, [selectedKey]);

  useEffect(() => {
    if (frozenKey !== title) {
      setIsFrozen(false);
      setFrozenData(null);
    }
  }, [frozenKey, title]);

  const hasData = Array.isArray(dataToRender) && dataToRender.length > 0;

  if (!hasData) {
    return (
      <div className="chart-card">
        <h3>{title}</h3>
        <div className="chart-body empty">
          <p style={{ textAlign: "center", color: "#888", margin: "20px 0" }}>
            Sin datos disponibles
          </p>
        </div>
      </div>
    );
  }



  const handleSliceClick = (data) => {
    handleClickLogic({
      data,
      xKey,
      selectedCategory,
      isFrozen,
      showData,
      setIsFrozen,
      setFrozenData,
      setSelectedCategory,
      onBarClick,
    });
  };

  const renderCustomLegend = (props) => {
    const { payload } = props;
    return (
      <ul style={{
        listStyle: "none",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: 0,
        marginTop: 10
      }}>
        {payload.map((entry, index) => (
          <li
            key={`item-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              marginRight: 15,
              fontSize: 14,
              color: "#000",
              fontWeight: "500"
            }}
          >
            <span
              style={{
                width: 12,
                height: 12,
                backgroundColor: entry.color,
                display: "inline-block",
                marginRight: 6,
                borderRadius: 2
              }}
            ></span>
            {entry.value}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className="chart-card">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={dataToRender}
            dataKey="total"
            nameKey={xKey}
            cx="50%"
            cy="45%"
            innerRadius="70%"
            outerRadius="100%"
            paddingAngle={3}
            label={({ cx, cy, midAngle, innerRadius, outerRadius, percent, value }) => {
              const RADIAN = Math.PI / 180;
              const radius = innerRadius + (outerRadius - innerRadius) / 2;
              const x = cx + radius * Math.cos(-midAngle * RADIAN);
              const y = cy + radius * Math.sin(-midAngle * RADIAN);
              return (
                <text
                  x={x}
                  y={y}
                  fill="#fff"
                  textAnchor="middle"
                  dominantBaseline="central"
                  fontSize={12}
                  fontWeight="bold"
                >
                  {value}
                </text>
              );
            }}
            onClick={handleSliceClick}
          >
            {dataToRender.map((entry, index) => {
              const isSelected = selectedCategory === entry.name;
              const opacity = isFrozen
                ? selectedCategory && !isSelected ? 0.4 : 1
                : 1;
              return (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                  stroke={isSelected ? "#333" : "none"}
                  strokeWidth={isSelected ? 2 : 0}
                  fillOpacity={opacity}
                  cursor="pointer"
                />
              );
            })}
          </Pie>
          <Tooltip />
          <Legend content={renderCustomLegend}
            layout="vertical"
            align="right"
            verticalAlign="middle" />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default CustomPieChart;